import React from "react";
import "./Contact.css";

const Location = () => {
  return (
    <>
        <div className="flex flex-col location-container">
        <h1 className="text-4xl pb-8 pt-[20px] px-[20px] w-full font-Poppins font-semibold">
              Unsere <span className="text-primary">Adresse</span>
            </h1>
          <iframe
            className="w-full h-96"
            width="100%"
            height="100%"
            title="map"
            src="https://www.google.com/maps/embed/v1/place?q=Roseggerstraße+23,+5020+Salzburg,+Austria&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8"
          ></iframe>
          <div className="button-container text-center pt-4">
          <a
  className="transport-button fa fa-train text-primary text-2xl"
  href="https://www.google.com/maps/dir/?api=1&destination=Roseggerstraße+23,+5020+Salzburg,+Austria&travelmode=transit"
  target="_blank"
  rel="noopener noreferrer"
>
</a>
          <a
  className="transport-button fa fa-car text-primary text-2xl"
  href="https://www.google.com/maps/dir/?api=1&destination=Roseggerstraße+23,+5020+Salzburg,+Austria&travelmode=driving"
  target="_blank"
  rel="noopener noreferrer"
>
</a>
<a
  className="transport-button fa fa-bicycle text-primary text-2xl"
  href="https://www.google.com/maps/dir/?api=1&destination=Roseggerstraße+23,+5020+Salzburg,+Austria&travelmode=bicycling"
  target="_blank"
  rel="noopener noreferrer"
>
</a>            
<a
  className="transport-button fa fa-walking text-primary text-2xl"
  href="https://www.google.com/maps/dir/?api=1&destination=Roseggerstraße+23,+5020+Salzburg,+Austria&travelmode=walking"
  target="_blank"
  rel="noopener noreferrer"
>
</a>                
          </div>
        </div>
    </>
  );
};

export default Location;
